<div id="home-casos-exito" class="container-fluid bg-primary-100">
    <div class="container">
        <div class="row py-5">
            <div class="col-12 col-lg-8 pe-5 mb-4 mb-lg-0">
                <span class="material-symbols-outlined mat-icon-size-50 primary-900 d-block d-lg-none mb-3">workspace_premium</span>
                <p class="tab-ancla primary-900 mb-2">CASOS DE ÉXITO</p>
                <h1 class="primary-900 mb-2">¡Éxitos que hablan por sí solos!</h1>
                <p class="p1-regular primary-900">
                    Nuestros casos de éxito son solo ejemplos de cómo hemos ayudado a nuestros clientes a <strong class="p1-bold">lograr
                        sus metas y alcanzar su máximo potencial.</strong> ¡Únete a nosotros y descubre tu propio caso
                    de éxito financiero!
                </p>
            </div>
            <div class="col-12 col-lg-4 d-flex flex-column justify-content-center align-items-center px-lg-5">
                <span
                    class="mat-icon-size-50 material-symbols-outlined primary-900 d-none d-lg-block mb-2">workspace_premium</span>
                <a [routerLink]="['/casos-exito']" class="btn btn-secondary border-2 w-100 mx-lg-5 mt-3"
                    title="Descúbrelos">Descúbrelos</a>
            </div>
        </div>
    </div>
</div>